
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBeaconGeneralCube as ObiBeaconGeneralCubeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-beacon-general-cube.js';
 
 
 

 
 export const ObiBeaconGeneralCube = createComponent({
   react: React,
   tagName: 'obi-beacon-general-cube',
   elementClass: ObiBeaconGeneralCubeElement,
   events: {
     
   }
  });
 
 